import { generateSkuCode } from "core/helpers";
import type { Ga4Item } from "shared/interfaces";

import type { CartItem } from "~/common/interfaces/cart-item.interface";

export const getGa4ItemFromCartItem = (cartItem: CartItem): Ga4Item => ({
	item_id: cartItem.product.id.toString(),
	item_name: cartItem.product.name,
	item_category: cartItem.product.kind.name,
	item_variant: generateSkuCode(cartItem.product.id, cartItem.material.id, cartItem.size.id),
	price: cartItem.pricePolicy?.price ?? 0,
	quantity: cartItem.amount ?? 1
});
